import type { ICreatePBTCaseRequest, IBulkCreatePBTCaseRequest } from '../../../Interfaces/ICRMCase';
import type { IPBTCase } from '../../../Interfaces/IPBTCase';
import type { IBulkCreateError, IExcelUploadResult } from './types';
import { PBTCreateCaseActionType } from './action-types';

interface ICreateCaseRequestAction {
  type: typeof PBTCreateCaseActionType.CREATE_CASE_REQUEST;
  payload: ICreatePBTCaseRequest;
}

interface ICreateCaseSuccessAction {
  type: typeof PBTCreateCaseActionType.CREATE_CASE_SUCCESS;
  payload: IPBTCase;
}

interface ICreateCaseErrorAction {
  type: typeof PBTCreateCaseActionType.CREATE_CASE_ERROR;
  payload: string;
}

interface ICreateCaseResetAction {
  type: typeof PBTCreateCaseActionType.CREATE_CASE_RESET;
}

interface IBulkCreateRequestAction {
  type: typeof PBTCreateCaseActionType.BULK_CREATE_REQUEST;
  payload: IBulkCreatePBTCaseRequest;
}

interface IBulkCreateSuccessAction {
  type: typeof PBTCreateCaseActionType.BULK_CREATE_SUCCESS;
  payload: { successCount: number; failureCount: number; blockedCount?: number; warningCount?: number; errors?: IBulkCreateError[] };
}

interface IBulkCreateErrorAction {
  type: typeof PBTCreateCaseActionType.BULK_CREATE_ERROR;
  payload: string;
}

interface IExcelUploadRequestAction {
  type: typeof PBTCreateCaseActionType.EXCEL_UPLOAD_REQUEST;
  payload: { file: File };
}

interface IExcelUploadSuccessAction {
  type: typeof PBTCreateCaseActionType.EXCEL_UPLOAD_SUCCESS;
  payload: IExcelUploadResult;
}

interface IExcelUploadErrorAction {
  type: typeof PBTCreateCaseActionType.EXCEL_UPLOAD_ERROR;
  payload: string;
}

export type PBTCreateCaseAction =
  | ICreateCaseRequestAction
  | ICreateCaseSuccessAction
  | ICreateCaseErrorAction
  | ICreateCaseResetAction
  | IBulkCreateRequestAction
  | IBulkCreateSuccessAction
  | IBulkCreateErrorAction
  | IExcelUploadRequestAction
  | IExcelUploadSuccessAction
  | IExcelUploadErrorAction;

export const createCaseRequest = (payload: ICreatePBTCaseRequest): ICreateCaseRequestAction => ({
  type: PBTCreateCaseActionType.CREATE_CASE_REQUEST,
  payload,
});

export const createCaseSuccess = (pbtCase: IPBTCase): ICreateCaseSuccessAction => ({
  type: PBTCreateCaseActionType.CREATE_CASE_SUCCESS,
  payload: pbtCase,
});

export const createCaseError = (errorMessage: string): ICreateCaseErrorAction => ({
  type: PBTCreateCaseActionType.CREATE_CASE_ERROR,
  payload: errorMessage,
});

export const createCaseReset = (): ICreateCaseResetAction => ({
  type: PBTCreateCaseActionType.CREATE_CASE_RESET,
});

export const bulkCreateRequest = (payload: IBulkCreatePBTCaseRequest): IBulkCreateRequestAction => ({
  type: PBTCreateCaseActionType.BULK_CREATE_REQUEST,
  payload,
});

export const bulkCreateSuccess = (successCount: number, failureCount: number, blockedCount?: number, warningCount?: number, errors?: IBulkCreateError[]): IBulkCreateSuccessAction => ({
  type: PBTCreateCaseActionType.BULK_CREATE_SUCCESS,
  payload: { successCount, failureCount, blockedCount, warningCount, errors },
});

export const bulkCreateError = (errorMessage: string): IBulkCreateErrorAction => ({
  type: PBTCreateCaseActionType.BULK_CREATE_ERROR,
  payload: errorMessage,
});

export const excelUploadRequest = (file: File): IExcelUploadRequestAction => ({
  type: PBTCreateCaseActionType.EXCEL_UPLOAD_REQUEST,
  payload: { file },
});

export const excelUploadSuccess = (result: IExcelUploadResult): IExcelUploadSuccessAction => ({
  type: PBTCreateCaseActionType.EXCEL_UPLOAD_SUCCESS,
  payload: result,
});

export const excelUploadError = (errorMessage: string): IExcelUploadErrorAction => ({
  type: PBTCreateCaseActionType.EXCEL_UPLOAD_ERROR,
  payload: errorMessage,
});
